window.dtScheduleTemplate = function () {
  const dt_schedule_template = new DataTable('#schedule-template-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#schedule-template-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#schedule-template-datatable', 3); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[1, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "name" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    },
  });

  dtFinalTouch()
}